/* 
  Sport Pages Dynamic Translator
  This securely maintains the user's language preference across sport pages via localStorage.
*/

window.sportTranslations = {
    // ---- Dashboard ----
    "Profilul Meu": "My Profile",
    "Cont Shopify": "Shopify Account",
    "Cont NMN România": "NMN Romania Account",
    "Profilul tău de performanță biologică": "Your biological performance profile",
    "Inițiază Scanare Nouă": "Start New Scan",
    "Completări": "Submissions",
    "chestionare completate": "completed questionnaires",
    "Protocol Salvat": "Saved Protocol",
    "produse în protocol": "products in protocol",
    "Comenzi Shopify": "Shopify Orders",
    "comenzi plasate": "orders placed",
    "Poziția Ta în Comunitate": "Your Position in the Community",
    "Scor Biologic": "Biological Score",
    "Se calculează...": "Calculating...",
    "Angajament — Comenzi": "Engagement — Orders",
    "Ultima Scanare — Scoruri": "Latest Scan — Scores",
    "Se încarcă...": "Loading...",
    "Protocolul Meu Salvat": "My Saved Protocol",
    "Istoricul Scanărilor": "Scan History",
    "click pe un scan pentru detalii": "click on a scan for details",
    "Articole Salvate": "Saved Articles",
    "Centrul meu de comandă": "My command center",
    "Optimizarea Performanței": "Performance Optimization",
    "Creează-ți Protocolul": "Build Your Protocol",
    "Contul Meu": "My Account",
    "Planuri": "Pathways",
    "Coș": "Cart",
    "Bun venit": "Welcome",
    "PROFIL ACTIV /": "ACTIVE PROFILE /",
    "COMENZI": "ORDERS",
    "PREVIEW MODE": "PREVIEW MODE",
    "din toți eroii de aici": "of all heroes here",
    "Scor total:": "Total score:",
    "Bazat pe ultima scanare": "Based on last scan",
    "Mă loghez": "Sign In",
    "Creează cont gratuit": "Create free account",
    "ACCES RESTRICȚIONAT": "RESTRICTED ACCESS",
    "Profilul tău de performanță": "Your performance profile",
    "Loghează-te pentru a vizualiza istoricul protocoalelor, produsele salvate și evoluția scorurilor tale biologice.": "Sign in to view your protocol history, saved products, and the evolution of your biological scores.",
    "Nicio scanare încă.": "No scan yet.",
    "Inițiază prima scanare →": "Start your first scan →",
    "Niciun produs salvat.": "No products saved.",
    "Mergi la Protocol Builder →": "Go to Protocol Builder →",
    "Scoruri sisteme": "System scores",
    "Produse recomandate": "Recommended products",
    "Sisteme prioritare": "Priority systems",
    "Toate sistemele optime": "All systems optimal",
    "+ Adaugă din Protocol Builder": "+ Add from Protocol Builder",
    "Niciun articol salvat.": "No saved articles.",
    "Descoperă articole în Protocol Builder →": "Discover articles in Protocol Builder →",
    "Salvat pe": "Saved on",
    "Vezi Produsul": "View Product",
    "Motorul Energetic": "Energy Engine",
    "Capacitate de Refacere": "Recovery Capacity",
    "Rezistența Structurală": "Structural Resilience",
    "Echilibru Anabolic": "Anabolic Balance",
    "Reziliența SN": "NS Resilience",

    // ---- Missing Dashboard UI & Uppercase ----
    "POZIȚIA TA ÎN COMUNITATE": "YOUR POSITION IN THE COMMUNITY",
    "SCOR BIOLOGIC": "BIOLOGICAL SCORE",
    "ANGAJAMENT – COMENZI": "ENGAGEMENT – ORDERS",
    "ULTIMA SCANARE – SCORURI": "LATEST SCAN – SCORES",
    "PROTOCOLUL MEU SALVAT": "MY SAVED PROTOCOL",
    "DIN TOȚI EROII DE AICI": "OF ALL HEROES HERE",
    "Ești la început — primul pas e cel mai important. Continuă scanările și urmărește evoluția.": "You're at the beginning — the first step is the most important. Keep scanning and track your evolution.",
    "ești pe drumul cel bun.": "you're on the right track.",
    "Ești în top! Mai ai un pas până la optimizarea completă.": "You are in the top! One step away from complete optimization.",
    "Nivel maxim atins. Ești un exemplu de longevitate!": "Maximum level reached. You are an example of longevity!",
    "Pe calea spre optimizare biologică completă": "On the path to complete biological optimization",
    "comenzi, ești printre cei mai implicați clienți": "orders, you are among the most engaged clients",
    "ai portalului sport!": "of the sport portal!",
    "Cu ": "With ",
    "Scor total:": "Total score:",
    "Bazat pe ultima scanare": "Based on last scan",
    "Ultima scanare:": "Last scan:",
    "sisteme prioritare": "priority systems",
    "sistem prioritar": "priority system",

    // ---- Pathways & Mobile ----
    "Optimizarea Performanței": "Performance Pathways",
    "Alege după sistemul biologic": "Choose by Biological System",
    "Alege după Sport": "Choose by Sport",
    "OPTIMIZARE BIOLOGICĂ": "BIOLOGICAL OPTIMIZATION",
    "Selectează un sistem biologic pentru a vizualiza stack-ul de compuși asociați obiectivului tău.": "Select a biological system to view the stack of compounds associated with your goal.",
    "GHID DE ORIENTARE": "GUIDE",
    "Experiența ta aici explicată pas cu pas": "Your experience here, explained step by step",
    "Explorezi sistemele metabolice, primești recomandări personalizate și îți urmărești totul în Contul Meu.": "You explore metabolic systems, receive personalized recommendations, and track everything in My Account.",
    "Vezi cum funcționează": "See how it works",
    "Creează-ți protocolul": "Build your protocol",
    "Experiența sport este construită ca un sistem conectat. Începi cu explorarea categoriilor metabolice, continui cu un protocol personalizat bazat pe sportul practicat și datele tale, iar apoi revii în Contul Meu pentru scanări, produse și articole salvate.": "The sport experience is built as a connected system. You start by exploring metabolic categories, continue with a personalized protocol based on your sport and personal data, then return to My Account for scans, saved products, and saved articles.",
    "Explorezi sisteme pe această pagină": "Explore systems on this page",
    "Vezi categoriile biologice și compușii recomandați pentru fiecare zonă importantă pentru performanță. Sau vezi direct recomandările în funcție de sportul practicat.": "See the biological categories and recommended compounds for each area that matters for performance. Or view recommendations directly based on the sport you practice.",
    "Îți creezi protocolul": "Build your protocol",
    "Completezi chestionarul, iar sistemul generează recomandări în funcție de sportul practicat și datele tale personale.": "You complete the questionnaire, and the system generates recommendations based on your sport and personal data.",
    "Salvezi și urmărești în Contul Meu": "Save and track in My Account",
    "Îți păstrezi protocolul, produsele, articolele și istoricul scanărilor într-un singur loc.": "Keep your protocol, products, articles, and scan history in one place.",
    "Vezi Contul Meu": "View My Account",
    "Restrânge": "Collapse",
    "Poți începe de aici, apoi revii oricând la recomandările salvate în cont.": "You can start here, then return anytime to the recommendations saved in your account.",
    "MENIU NAVIGARE": "NAVIGATION MENU",
    "Toate Rutele": "All Pathways",
    "Alege după Sport": "Choose by Sport",
    "Selectează un Sport": "Select a Sport",
    "Alege un sport din listă pentru a vedea": "Choose a sport from the list to see",
    "protocolul optimizat de suplimentare.": "the optimized supplementation protocol.",
    "SUPORT SPORTIV": "SPORT SUPPORT",
    "Suplimente recomandate pentru sportul tău": "Recommended supplements for your sport",
    "Creșterea Performanței": "Performance Boost",
    "Recuperare & Refacere": "Recovery & Restoration",
    "Personalizează cu Protocol Builder": "Personalize with Protocol Builder",
    "MENIU NAVIGARE": "NAVIGATION MENU",
    "Toate Rutele": "All Pathways",
    "Alege o zonă pentru a vedea cum": "Choose an area to see how",
    "optimizăm performanța celulară.": "we optimize cellular performance.",
    "Filtrează": "Filter",
    "Închide filtrele": "Close filters",
    "vezi produsele științifice": "view scientific products",
    "Toate Nivelurile": "All Levels",
    "Începător": "Beginner",
    "Avansat": "Advanced",
    "PRO": "PRO",
    "Focus Principal": "Main Focus",
    "Energie & Mitocondrii": "Energy & Mitochondria",
    "Recuperare & Somn": "Recovery & Sleep",
    "Fizic & Articulații": "Physical & Joints",
    "Găsește soluția...": "Find the solution...",

    // Sport Names
    "Alergare": "Running",
    "Ciclism": "Cycling",
    "Fotbal": "Soccer",
    "Tenis / Padel": "Tennis / Padel",
    "Înot": "Swimming",
    "Fitness / Sală": "Fitness / Gym",
    "Drumeții": "Hiking",
    "Yoga / Pilates": "Yoga / Pilates",
    "Box / MMA": "Boxing / MMA",
    "Schi / Snowboard": "Skiing / Snowboard",

    // Sport Benefits (Why)
    "Energie mitocondrială pentru anduranță susținută": "Mitochondrial energy for sustained endurance",
    "Hidratare celulară și rezistență la efort": "Cellular hydration and effort resistance",
    "Previne crampele și susține somnul profund": "Prevents cramps and supports deep sleep",
    "Reduce inflamația articulară post-efort": "Reduces joint inflammation post-exercise",
    "Crește NAD+ pentru energie pe distanță lungă": "Increases NAD+ for long-distance energy",
    "Suport cardiovascular și anti-inflamator": "Cardiovascular support and anti-inflammatory",
    "Regenerare celulară și reducere stres oxidativ": "Cellular regeneration and oxidative stress reduction",
    "Relaxare musculară și recuperare nervos": "Muscle relaxation and nerve recovery",
    "Forță explozivă și sprint-uri repetate": "Explosive strength and repeated sprints",
    "Energie susținută pe tot parcursul meciului": "Sustained energy throughout the match",
    "Anti-inflamator natural pentru articulații": "Natural anti-inflammatory for joints",
    "Accelerează recuperarea musculară": "Accelerates muscle recovery",
    "Putere explosivă în lovituri și deplasări": "Explosive power in hits and moves",
    "Focus și rezistența la oboseală": "Focus and fatigue resistance",
    "Protecție articulară pentru genunchi și coate": "Joint protection for knees and elbows",
    "Relaxare neuromusculară post-meci": "Post-match neuromuscular relaxation",
    "Performanță aerobă și capacitate pulmonară": "Aerobic performance and lung capacity",
    "Suport cardiovascular în efort susținut": "Cardiovascular support in sustained effort",
    "Reduce tensiunea musculară": "Reduces muscle tension",
    "Antioxidant puternic post-efort": "Strong antioxidant post-exercise",
    "Creșterea forței și a masei musculare": "Increased strength and muscle mass",
    "Suport hormonal și vitalitate (35+)": "Hormonal support and vitality (35+)",
    "Protecție tendoane și țesut conjunctiv": "Tendon and connective tissue protection",
    "Somn profund și recuperare optimă": "Deep sleep and optimal recovery",
    "Energie celulară pe trasee lungi": "Cellular energy on long trails",
    "Rezistență articulară și cardiovasculară": "Joint and cardiovascular endurance",
    "Refacerea articulațiilor după efort": "Joint recovery after effort",
    "Reduce rigiditatea musculară": "Reduces muscle stiffness",
    "Reduce cortizolul, crește focusul": "Reduces cortisol, increases focus",
    "Flexibilitate și funcție nervoasă": "Flexibility and nerve function",
    "Susține elasticitatea țesuturilor": "Supports tissue elasticity",
    "Relaxare profundă și calm mental": "Deep relaxation and mental calm",
    "Putere explosivă în lovituri": "Explosive power in shots",
    "Energie și rezistență în runde": "Energy and endurance in rounds",
    "Reducere rapidă a inflamației": "Rapid inflammation reduction",
    "Regenerare celulară după impact": "Cellular regeneration after impact",
    "Energie la altitudine și efort intens": "Energy at altitude and intense effort",
    "Forță în viraje și stabilitate": "Strength in turns and stability",
    "Protejează articulațiile genunchilor": "Protects knee joints",
    "Suport cartilaj după efortul de schi": "Cartilage support after skiing",


    // Product Category Translations
    "Energie / NAD+": "Energy / NAD+",
    "Longevitate / Antioxidant": "Longevity / Antioxidant",
    "Forță / ATP Rapid": "Strength / Fast ATP",
    "Energie Celulară": "Cellular Energy",
    "Electrolitic / Anduranță": "Electrolytic / Endurance",
    "Energie Mitocondrială": "Mitochondrial Energy",
    "Anti-inflamator / Cardiovascular": "Anti-inflammatory / Cardiovascular",
    "Cognitiv / Somn": "Cognitive / Sleep",
    "Cognitiv / Recuperare": "Cognitive / Recovery",
    "Recuperare / Hormonal": "Recovery / Hormonal",
    "Muscular / Crampe": "Muscular / Cramps",
    "Hormonal / Testosteron": "Hormonal / Testosterone",
    "Anti-inflamator Natural": "Natural Anti-inflammatory",
    "Antioxidant Celular": "Cellular Antioxidant",
    "Detoxifiere / Celular": "Detoxification / Cellular",
    "Glutation / Regenerare": "Glutathione / Regeneration",
    "Tamponare Acidă / Anaerob": "Acid Buffering / Anaerobic",
    "Tendoane / Articulații": "Tendons / Joints",
    "Sinteză Colagen": "Collagen Synthesis",
    "Cartilaj / Mobilitate": "Cartilage / Mobility",
    "Lubrifiere Articulară": "Joint Lubrication",
    "Glicemie / Metabolism": "Glycemia / Metabolism",
    "Metilare / Cardiovascular": "Methylation / Cardiovascular",
    "Antioxidant / Imunitate": "Antioxidant / Immunity",
    "Osos / Hormonal": "Bone / Hormonal",
    "Somn / Nervos": "Sleep / Nervous",
    "Sănătate Celulară": "Cellular Health",
    "Autofagie / Longevitate": "Autophagy / Longevity",
    "Mitofagie / Longevitate": "Mitophagy / Longevity",
    "Antioxidant / Colagen": "Antioxidant / Collagen",
    "Adaptogen / Cortizol": "Adaptogen / Cortisol",
    "Adaptogen / Oboseală": "Adaptogen / Fatigue",
    "Sinteză Proteică": "Protein Synthesis",
    "Hormonal / Imunitate": "Hormonal / Immunity",
    "Focus / Anti-anxietate": "Focus / Anti-anxiety",
    "Metabolism Neural": "Neural Metabolism",

    // Product Name Translations
    "Taurină": "Taurine",
    "Spermidină": "Spermidine",
    "Curcumină": "Curcumin",
    "Magneziu Complex": "Magnesium Complex",
    "Vitamina C liposomală": "Liposomal Vitamin C",
    "Glucozamină": "Glucosamine",
    "Creatină": "Creatine",
    "Vitamina D3K2 400k UI": "Vitamin D3K2 400k UI",
    "Magneziu": "Magnesium",
    "Colagen": "Collagen",
    "Vitamina B Complex": "Vitamin B Complex",
    "Apigenină": "Apigenin",
    "Fisetină": "Fisetin",
    "L-Theanină": "L-Theanine",
    "Berberină": "Berberine",
    "Carnosină": "Carnosine",
    "Astaxantină": "Astaxanthin",
    "ProLithin A (Urolithin A)": "ProLithin A (Urolithin A)",
    "Tongkat Ali": "Tongkat Ali",
    "Zinc": "Zinc",
    "Coenzima Q10": "Coenzyme Q10",
    "Ashwagandha": "Ashwagandha",
    "Rhodiola": "Rhodiola",
    "EAA (Aminoacizi Esențiali)": "EAA (Essential Amino Acids)",
    "GlyNAC": "GlyNAC",
    "Omega 3": "Omega 3",
    "Colagen (Kollagen Peptide)": "Collagen (Kollagen Peptide)",
    "Collagen Booster": "Collagen Booster",
    "Hyaluron": "Hyaluron",
    "Magneziu (suport muscular & crampe)": "Magnesium (muscle support & cramps)",
    "Magtein (Mg L-Treonat)": "Magtein (Mg L-Threonate)",
    "Quercetin (Quercesome + pulbere)": "Quercetin (Quercesome + powder)",
    "Quercesome (Quercetin)": "Quercesome (Quercetin)",
    "CAAKG": "CAAKG",
    "CaAKG": "CaAKG",
    "Magneziu L-Treonat": "Magnesium L-Threonate",

    // ---- Protocol Builder ----
    "Pasul": "Step",
    "Selectează intensitatea disconfortului / nevoii": "Select the intensity of discomfort / need",
    "Înapoi": "Back",
    "Continuă": "Continue",
    "Analizează Scorul": "Analyze Score",
    "Scorul Tău Biologic": "Your Biological Score",
    "Prioritățile Tale": "Your Priorities",
    "Produse Sugerate": "Suggested Products",
    "Adaugă la Protocol": "Add to Protocol",
    "Sistem Stabil": "Stable System",
    "Sistem cu Nevoi Moderate": "System with Moderate Needs",
    "Sistem Prioritar": "Priority System",
    "Vezi Articol": "View Article",

    // ---- Missing Builder & Systems ----
    "SISTEM ACTIV": "ACTIVE SYSTEM",
    "Reziliența Sistemului Nervos": "Nervous System Resilience",
    "/// Funcție Neuromusculară": "/// Neuromuscular Function",
    "Focus, stres, coordonare, refacere neuro-musculară.": "Focus, stress, coordination, neuromuscular recovery.",
    "COMPUȘI ESENȚIALI": "ESSENTIAL COMPOUNDS",
    "Echilibrul Anabolic (35+)": "Anabolic Balance (35+)",
    "Capacitatea de Refacere": "Recovery Capacity",
    "/// Anduranță Mitocondrială": "/// Mitochondrial Endurance",
    "Recuperare musculară, stres oxidativ, inflamație, somn profund.": "Muscle recovery, oxidative stress, inflammation, deep sleep.",
    "/// Optimizare Anabolică": "/// Anabolic Optimization",
    "Masă musculară, semnalizare hormonală, forță, vitalitate masculină.": "Muscle mass, hormonal signaling, strength, male vitality.",
    "SISTEM EXPERT / ALGORITM DE RECOMANDARE": "EXPERT SYSTEM / RECOMMENDATION ALGORITHM",
    "Construiește-ți Protocolul.": "Build your Protocol.",
    "Folosește senzorii de diagnostic de mai jos pentru a-ți defini nivelul de optimizare actual pe cele 5 mari sisteme biologice. Mută indicatorul spre stânga (Roșu) dacă te lovești de o problemă critică, și spre dreapta (Verde) dacă sistemul funcționează optim.": "Use the diagnostic sensors below to define your current level of optimization across the 5 major biological systems. Move the indicator to the left (Red) if you are facing a critical issue, and to the right (Green) if the system is functioning optimally.",

    // ---- Protocol Results ----
    "Scanarea este completă. Profilul tău indică o nevoie imediată de optimizare în ": "The scan is complete. Your profile indicates an immediate need for optimization in ",
    " sisteme": " systems",
    " (Intervenție Prioritară), în timp ce ": " (Priority Intervention), while ",
    " funcționează optim, necesitând protecție minimă.": " function optimally, requiring minimal protection.",
    "INTERVENȚIE PRIORITARĂ": "PRIORITY INTERVENTION",
    "PROTOCOL COMPLET:": "COMPLETE PROTOCOL:",
    "(click pe produs pentru detalii)": "(click product for details)",
    "Adaugă tot în Protocol": "Add all to Protocol",
    "Întreținere și Prevenție Optimă": "Optimal Maintenance and Prevention",
    "ECHILIBRU OPTIM": "OPTIMAL BALANCE",
    "RECOMANDARE MINIMĂ:": "MINIMUM RECOMMENDATION:",
    "Salvează în Protocol": "Save to Protocol",
    "Salvează toate ": "Save all ",
    " suplimentele din această categorie în profilul tău": " supplements from this category to your profile",
    "INIȚIAZĂ SCANAREA": "INITIATE SCAN",
    "SISTEM EXPERT v2.0": "EXPERT SYSTEM v2.0",
    "Lectură recomandată": "Recommended reading",
    "Articole relevante pentru sistemele tale prioritare": "Relevant articles for your priority systems",
    "Citește": "Read",
    "Salvează": "Save",
    "Salvat": "Saved",
    "Articol salvat pentru mai târziu!": "Article saved for later!",

    // ---- Builder Inputs & Levels ----
    "SETARE PARAMETRI BIOLOGICI (Evaluare Stare Curentă)": "BIOLOGICAL PARAMETERS SETUP (Current State Evaluation)",
    "NIVEL 1 / DECLIN CRITIC FUNCȚIONAL": "LEVEL 1 / CRITICAL FUNCTIONAL DECLINE",
    "NIVEL 2 / AVERTISMENT SEVER": "LEVEL 2 / SEVERE WARNING",
    "NIVEL 3 / DEFICIT MODERAT": "LEVEL 3 / MODERATE DEFICIT",
    "NIVEL 4 / DEZORDONARE UȘOARĂ": "LEVEL 4 / MILD DISORDER",
    "NIVEL 5 / ECHILIBRU OPTIM": "LEVEL 5 / OPTIMAL BALANCE",
    "EPUIZARE TOTALĂ": "TOTAL EXHAUSTION",
    "INSOMNII SEVERE": "SEVERE INSOMNIA",
    "DURERI MAJORE": "MAJOR PAIN",
    "Echilibrul Anabolic": "Anabolic Balance",
    "SCĂDERE ADEVĂRATĂ": "TRUE DECLINE",
    "ANXIETATE SEVERĂ": "SEVERE ANXIETY",
    "ECHILIBRU OPTIM": "OPTIMAL BALANCE",
    "SISTEM PREGĂTIT PENTRU ANALIZA BIOMETRICĂ": "SYSTEM READY FOR BIOMETRIC ANALYSIS",
    "NOTĂ: DREAPTA = PROBLEMĂ SEVERĂ": "NOTE: RIGHT = SEVERE PROBLEM",
    "Rezultat Algoritm": "Algorithm Result",
    "BIOLOGIE MAPATĂ": "MAPPED BIOLOGY",
    "Resetează": "Reset",
    "Deficit Energie & Oboseală Celulară (Dimineața)": "Energy Deficit & Cellular Fatigue (Morning)",
    "Optimizează direct energia celulară de la prima oră și corectează oboseala vizibilă.": "Optimizes cellular energy first thing in the morning and corrects visible fatigue.",
    "Deficit de Somn, Inflamație & Recuperare Lentă": "Sleep Deficit, Inflammation & Slow Recovery",
    "Combate deficitul de somn, recuperează sistemul de anduranță și stinge inflamația.": "Combats sleep deficit, recovers the endurance system, and reduces inflammation.",
    "Stres Articular / Sensibilitate Tendoane & Fascia": "Joint Stress / Tendon & Fascia Sensitivity",
    "Refacere rapidă pentru cartilaje iritate, tendoane vulnerabile și fascia.": "Rapid recovery for irritated cartilage, vulnerable tendons, and fascia.",
    "Deficit de Forță, Masă Musculară & Vitalitate (Hormonal)": "Strength, Muscle Mass & Vitality Deficit (Hormonal)",
    "Suport hormonal necesar când epuizarea afectează vitalitatea și forța.": "Hormonal support needed when exhaustion affects vitality and strength.",
    "Nivel de Anxietate, Stres Mental & Pierdere Focus": "Anxiety Level, Mental Stress & Loss of Focus",
    "Calmează mintea suprastimulată, stinge anxietatea și îmbunătățește focus-ul.": "Calms the overstimulated mind, extinguishes anxiety, and improves focus.",
    "Transferă în Shopify (Checkout) ": "Transfer to Shopify (Checkout) "
};

// Auto run
(function () {
    const langKey = 'sport_lang';
    let currentLang = localStorage.getItem(langKey) || 'ro'; // default is ro
    let originalTexts = new Map();

    // Sort translation keys by length descending to prevent partial match issues
    const sortedKeys = Object.keys(window.sportTranslations).sort((a, b) => b.length - a.length);

    // Expose global toggle
    window.setSportLanguage = function (targetLang) {
        if (targetLang === currentLang) return; // Ignore if already selected

        if (targetLang === 'ro') {
            localStorage.setItem(langKey, 'ro');
            window.location.reload();
        } else {
            currentLang = 'en';
            localStorage.setItem(langKey, 'en');
            applyTranslations();
            updateToggleButton();
        }
    };

    function updateToggleButton() {
        const desktopBtns = document.querySelectorAll('.sport-lang-btn');
        desktopBtns.forEach(btn => {
            btn.style.background = 'transparent';
            btn.style.color = 'var(--text-dim)';

            if (currentLang === 'en' && btn.classList.contains('sport-lang-en')) {
                btn.style.background = 'rgba(255,255,255,0.1)';
                btn.style.color = 'var(--text-main)';
            }
            if (currentLang === 'ro' && btn.classList.contains('sport-lang-ro')) {
                btn.style.background = 'rgba(255,255,255,0.1)';
                btn.style.color = 'var(--text-main)';
            }
        });

        // Mobile toggle styling check
        const mobileBtns = document.querySelectorAll('.mobile-lang-btn');
        mobileBtns.forEach(btn => {
            btn.style.opacity = '0.5';
            btn.style.fontWeight = 'normal';

            if (currentLang === 'en' && btn.classList.contains('mobile-lang-en')) {
                btn.style.opacity = '1';
                btn.style.fontWeight = 'bold';
            }
            if (currentLang === 'ro' && btn.classList.contains('mobile-lang-ro')) {
                btn.style.opacity = '1';
                btn.style.fontWeight = 'bold';
            }
        });
    }

    function getTextNodesIn(elem) {
        let textNodes = [];
        if (elem) {
            for (let nodes = elem.childNodes, i = nodes.length; i--;) {
                let node = nodes[i], nodeType = node.nodeType;
                if (nodeType == 3) {
                    textNodes.push(node);
                } else if (nodeType == 1 || nodeType == 9 || nodeType == 11) {
                    if (node.tagName !== "SCRIPT" && node.tagName !== "STYLE") {
                        textNodes = textNodes.concat(getTextNodesIn(node));
                    }
                }
            }
        }
        return textNodes;
    }

    window.applyTranslations = function () {
        if (currentLang === 'ro') return; // Handled by reload

        const textNodes = getTextNodesIn(document.body);
        textNodes.forEach(node => {
            // Prevent recursive translation of already translated nodes
            if (node._isSportTranslated) return;

            let val = node.nodeValue;
            if (!val || !val.trim()) return;

            let translated = val;
            let changed = false;

            for (const roText of sortedKeys) {
                const enText = window.sportTranslations[roText];
                if (translated.includes(roText)) {
                    translated = translated.split(roText).join(enText);
                    changed = true;
                }
            }

            if (changed) {
                node._isSportTranslated = true;
                if (!originalTexts.has(node)) {
                    originalTexts.set(node, val);
                }
                node.nodeValue = translated;
            }
        });

        // Input placeholders
        document.querySelectorAll('input[placeholder]').forEach(input => {
            const ph = input.getAttribute('placeholder');
            if (window.sportTranslations[ph]) {
                input.dataset.origPh = input.dataset.origPh || ph;
                input.setAttribute('placeholder', window.sportTranslations[ph]);
            }
        });
    };

    // Run on DCL
    document.addEventListener("DOMContentLoaded", () => {
        updateToggleButton();
        if (currentLang === 'en') {
            applyTranslations();
        }

        // Observer for dynamically added content (e.g. Supabase fetches)
        const observer = new MutationObserver((mutations) => {
            if (currentLang === 'en') {
                let shouldApply = false;
                for (let m of mutations) {
                    if (m.addedNodes.length > 0) {
                        // Only trigger if real elements were added (to prevent infinite loop with text nodes)
                        for (let n of m.addedNodes) {
                            if (n.nodeType === 1) {
                                shouldApply = true;
                                break;
                            }
                        }
                    }
                    if (shouldApply) break;
                }
                if (shouldApply) {
                    // Small delay to let framework render completely before changing text
                    setTimeout(applyTranslations, 50);
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    });
})();
